import React, { createContext, useEffect, ReactNode } from 'react'
import { useThemeStore } from '@/core/stores'

export type Theme = 'light' | 'dark' | 'system'
export type Language = 'en' | 'pt' | 'es' | 'fr'

export interface ThemeContextType {
  theme: Theme
  actualTheme: 'light' | 'dark'
  language: Language
  setTheme: (theme: Theme) => void
  setLanguage: (language: Language) => void
  toggleTheme: () => void
  isWebViewMode: boolean
  webViewParams: {
    theme?: string
    language?: string
  }
}

const ThemeContext = createContext<ThemeContextType | undefined>(undefined)

export interface ThemeProviderProps {
  children: ReactNode
  defaultTheme?: Theme
  defaultLanguage?: Language
}

export const ThemeProvider: React.FC<ThemeProviderProps> = ({
  children,
}) => {
  const {
    theme,
    actualTheme,
    language,
    setTheme,
    setLanguage,
    toggleTheme,
    isWebViewMode,
    webViewParams,
    initialize,
  } = useThemeStore()

  useEffect(() => {
    initialize()
  }, [initialize])

  const contextValue: ThemeContextType = {
    theme,
    actualTheme,
    language,
    setTheme,
    setLanguage,
    toggleTheme,
    isWebViewMode,
    webViewParams,
  }

  return (
    <ThemeContext.Provider value={contextValue}>
      {children}
    </ThemeContext.Provider>
  )
}

export { ThemeContext }
